import IconEdit from "@/app/(site)/_components/Atoms/Icons/IconEdit"
import { type CheckoutStep } from "@/app/(site)/contexts/ecommerce/types"
import { t } from "@/translations"

export default function EditButton({
    langCode,
    toStep,
    checkoutCurrentStep,
    setCheckoutCurrentStep,
    onEditClick
}: {
    langCode: string
    toStep?: CheckoutStep
    checkoutCurrentStep: CheckoutStep
    setCheckoutCurrentStep: (step: CheckoutStep) => void
    onEditClick?: () => void
}) {
    const handleClick = () => {
        if (toStep) {
            setCheckoutCurrentStep(toStep)
            // Call scroll callback after a small delay to ensure step change is processed
            if (onEditClick) {
                setTimeout(() => {
                    onEditClick()
                }, 100)
            }
        }
    }

    return (
        toStep &&
        checkoutCurrentStep > toStep && (
            <button
                onClick={handleClick}
                className="flex items-center gap-2 text-col-text-primary Trim_Mono_POC_Text_14_130_-5_400_uppercase hover:text-gray-900"
            >
                {t(langCode, "common.edit")}
                <IconEdit className="h-12 w-12" />
            </button>
        )
    )
}
